var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinusSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0.07 0.04 6 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17601664,0.38340864 L0.9585216,0.38340864 C0.64101132,0.38340864 0.38340864,0.64101132 0.38340864,0.9585216 L0.38340864,5.17601664 C0.38340864,5.49352692 0.64101132,5.7511296 0.9585216,5.7511296 L5.17601664,5.7511296 C5.49352692,5.7511296 5.7511296,5.49352692 5.7511296,5.17601664 L5.7511296,0.9585216 C5.7511296,0.64101132 5.49352692,0.38340864 5.17601664,0.38340864 Z M1.48570848,3.54652992 C1.40663045,3.54652992 1.34193024,3.48182971 1.34193024,3.40275168 L1.34193024,2.73178656 C1.34193024,2.65270853 1.40663045,2.58800832 1.48570848,2.58800832 L4.64882976,2.58800832 C4.72790779,2.58800832 4.792608,2.65270853 4.792608,2.73178656 L4.792608,3.40275168 C4.792608,3.48182971 4.72790779,3.54652992 4.64882976,3.54652992 L1.48570848,3.54652992 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusSquare);
export default __webpack_public_path__ + "static/media/minus-square.29a3eead5d2cba596f14ff84e789cff2.svg";
export { ForwardRef as ReactComponent };